<template>
  <el-button @click="onBtn" size="small" :type="params.typeStyle" style="margin-top:5px;">{{params.label}}</el-button>
</template>

<script>
export default {
  name: 'form-button',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    onBtn() {
      if (!this.params.fn) {
        return console.log('按钮配置有误！')
      }
      this.$emit(this.params.fn, this.params)
    }
  }
}
</script>
